export default function AboutMe() {
  return (
    <section id="AboutMe" className="about--section">
      <div className="about--section--img">
        <img src="./img/sahib_pic_1.png" alt="Self portrait" />
      </div>
      <div className="hero--section--content--box about--section--box">
        <div className="hero--section--content">
          <p className="section--title">About Me</p>
          <div className="hero--section-description">
            <p>
              I’m a Computer Engineering student based in the GTA, studying at the University of Guelph. I enjoy building systems that turn ideas into something real, whether that’s a cloud-based application, a backend service, or a tool that solves a problem I’ve actually run into.
            </p>
            <p>
              I’ve always liked taking something small, like an idea or a frustration, and turning it into something useful. A lot of what I build comes from that, whether it’s automating repetitive tasks or creating systems that make things run more smoothly.
            </p>
            <p>
              Lately, I’ve been focusing more on cloud platforms, data systems, and how AI can be used in practical ways. I still like exploring new technologies, but what matters most to me is building things that actually get used and make a difference.
            </p>
            <p>
              Outside of engineering, I spend time with my family and my dog, watch sports, and play video games. For me, tech has always been more than just code. It’s about creating things that make life a little easier and more enjoyable.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}